<template>
    <NuxtLink
        to="https://yandex.ru/maps/org/kromi/232772992131/reviews/?ll=30.378211%2C59.981317&z=13"
        target="_blank"
        class="relative overflow-hidden rounded-12 bg-yandex-score p-5">
        <div
            class="bg-noise absolute left-0 top-0 h-full w-full rounded-12"></div>
        <div class="relative">
            <div class="flex items-center space-x-3 text-20/120 font-semibold">
                <YandexIcon />
                <span>
                    {{ score.toFixed(1).replace('.', ',') }}
                </span>
                <div class="space-x-1">
                    <StarIcon
                        v-for="index in 5"
                        :key="`star-${index} score`"
                        :fill-percent="getFillPercent(index)"
                        class="inline align-baseline" />
                </div>
            </div>
            <div class="mt-3 text-12/140 font-medium text-accent-100">
                Рейтинг организации в Яндексе
            </div>
        </div>
    </NuxtLink>
</template>

<script setup lang="ts">
import StarIcon from '~/components/layouts/footer/svg/StarIcon.vue'
import YandexIcon from '~/components/layouts/footer/svg/YandexIcon.vue'

const props = defineProps({
    score: {
        type: Number as PropType<number>,
        required: true,
    },
})

function getFillPercent(index: number): number {
    if (index <= props.score) return 1

    return Math.max(0, props.score - (index - 1))
}
</script>
